import { render, staticRenderFns } from "./Maquina.vue?vue&type=template&id=1bbf9d4e&scoped=true&"
import script from "./Maquina.vue?vue&type=script&lang=js&"
export * from "./Maquina.vue?vue&type=script&lang=js&"
import style0 from "./Maquina.vue?vue&type=style&index=0&id=1bbf9d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbf9d4e",
  null
  
)

export default component.exports